import React, { useState, FormEvent, useEffect, useCallback } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation, Icon } from "@blueprintjs/core";
import { DateInput2 } from "@blueprintjs/datetime2";
import { format, parse, addDays} from "date-fns";
import { IconNames } from "@blueprintjs/icons";

import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';

import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSStkInfo, MarketInfo, MktFeeInfo, CurrencyInfo } from '../Types'
import { SystemHeader } from '../CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;

var UserID: string;
var PgmCode = "OM0001" ;
var isReqAuth2:boolean = false ;

interface FBSSmMastViewProps {
    gsb: AxiosInstance,
    stk: FBSStkInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
}


function FBSSmMastView({ gsb, stk = {} as FBSStkInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 }: FBSSmMastViewProps) {

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    const [isSLUserPress, setisSLUserPress] = useState(false)

    const [userKey, setuserKey] = useState("DEMO")

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                setuserKey(GsbFlag.user_key)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, stk])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    if (! ("d_StkNo" in stk)) return null

    
    return (
        <div>
            {/* define add,change,delete button */}
            { ViewMode === "V" && <div className="Row No-Print">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                {/* <Button className="Col-2-1" icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" icon="delete" onClick={() => onDelete()} >Delete</Button> */}
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

            </div> }
            { ViewMode === "L" && <div>
                Stock No. : {stk.d_StkNo}
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                <div className="Spacing-V-16" />
            </div> }

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Stock No." labelInfo="*">
                    <InputGroup readOnly value={stk.d_StkNo} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="Stock Code" labelInfo="*">
                    <InputGroup readOnly value={stk.d_StkCode} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-5" label="Stock Name">
                    <InputGroup readOnly value={stk.d_StkName} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-5" label="Stock Chinese Name" labelFor="inputStkChiName">
                    <InputGroup readOnly value={stk.d_Chi_Name_bg5} />
                </FormGroup>
            </div>

            <div className="Row">
                <FormGroup className="Col3-1-1" label="Market Code">
                    <InputGroup readOnly value={stk.d_Market} />
                </FormGroup>
                <FormGroup className="Col3-2-1" label="Fee Code">
                    <InputGroup readOnly value={stk.d_FeeCode} />
                </FormGroup>
                <FormGroup className="Col3-3-1" label="Currency">
                    <InputGroup readOnly value={stk.d_Currency} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Type">
                    <InputGroup readOnly value={stk.d_StkType} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Warrant/Rights Expiry Date">
                    <InputGroup readOnly value={utils.dispDate(stk.d_ExpiryDate, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="CCASS Stock">
                    <RadioGroup
                        name="d_CcassStk"
                        disabled={true}
                        inline={true}
                        selectedValue={stk.d_CcassStk}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
                <FormGroup className="Col-3-2" label="CCASS Trade On">
                    <InputGroup readOnly value={utils.dispDate(stk.d_CcassTradeOn, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Contract Stamp">
                    <RadioGroup
                        label="" 
                        name="d_Stamp"
                        disabled={true}
                        inline={true}
                        selectedValue={stk.d_Stamp}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Trade Suspended">
                    <RadioGroup
                        label="" 
                        name="d_TradeSuspended"
                        disabled={true}
                        inline={true}
                        selectedValue={stk.d_TradeSuspend}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                 </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Lot Size">
                    <InputGroup readOnly id="inputLotSize" name="d_LotSize" value={utils.formatNumber2(stk.d_LotSize)} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Price">
                    <InputGroup readOnly value={utils.formatNumber2(stk.d_StkPrice)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Grade">
                    <InputGroup readOnly value={stk.d_Grade} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Margin Ratio">
                    <InputGroup readOnly id="inputMarginRatio" name="d_MarginRatio" value={utils.formatNumber2(stk.d_MarginRatio)} />
                </FormGroup>
            </div>
            { stk.d_StkType == "O" && <div >
                <div className="Row">
                    <FormGroup className="Col-1-4"  >
                        <span id="DispText">For Option</span>
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-2" label="(Option) Underlying Stock No." labelFor="inputUnderlying_StkNo" labelInfo="">
                        <InputGroup readOnly value={stk.d_Underlying_StkNo} />
                    </FormGroup>
                    <FormGroup className="Col-3-1" label="Option Code" labelFor="inputRegister" labelInfo="">
                        <InputGroup readOnly value={stk.d_Register} />
                    </FormGroup>
                    <FormGroup className="Col-4-1" label="Trading Tariff" labelFor="inputTariff" labelInfo="">
                        <InputGroup readOnly value={utils.formatNumber2(stk.d_Tariff)} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-3-1" label="Option Code V1" labelFor="inputRegister" labelInfo="">
                        <InputGroup readOnly value={stk.d_Register1} />
                    </FormGroup>
                    <FormGroup className="Col-4-1" label="Trading Tariff V1" labelFor="inputTariff" labelInfo="">
                        <InputGroup readOnly value={utils.formatNumber2(stk.d_Tariff1)} />
                    </FormGroup>
                    <FormGroup className="Col-5-1" label="Lot Size V1" labelFor="inputRegister_LotSize" labelInfo="">
                        <InputGroup readOnly value={utils.formatNumber2(stk.d_Register1_LotSize)} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-3-1" label="Option Code V2" labelFor="inputRegister" labelInfo="">
                        <InputGroup readOnly value={stk.d_Register2} />
                    </FormGroup>
                    <FormGroup className="Col-4-1" label="Trading Tariff V2" labelFor="inputTariff" labelInfo="">
                        <InputGroup readOnly value={utils.formatNumber2(stk.d_Tariff2)} />
                    </FormGroup>
                    <FormGroup className="Col-5-1" label="Lot Size V2" labelFor="inputRegister_LotSize" labelInfo="">
                        <InputGroup readOnly value={utils.formatNumber2(stk.d_Register2_LotSize)} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-3-1" label="Option Code V3" labelFor="inputRegister" labelInfo="">
                        <InputGroup readOnly value={stk.d_Register3} />
                    </FormGroup>
                    <FormGroup className="Col-4-1" label="Trading Tariff V3" labelFor="inputTariff" labelInfo="">
                        <InputGroup readOnly value={utils.formatNumber2(stk.d_Tariff3)} />
                    </FormGroup>
                    <FormGroup className="Col-5-1" label="Lot Size V3" labelFor="inputRegister_LotSize" labelInfo="">
                        <InputGroup readOnly value={utils.formatNumber2(stk.d_Register3_LotSize)} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-2" label="Option Position Limit" labelFor="inputOption_Position_Limit">
                        <InputGroup readOnly id="inputLotSize" name="d_Option_Position_Limit" value={utils.formatNumber2(stk.d_Option_Position_Limit)} />
                    </FormGroup>
                    <FormGroup className="Col-3-2" label="Market Direction Limit" labelFor="inputMarket_Direction_Limit">
                        <InputGroup readOnly id="inputLotSize" name="d_Market_Direction_Limit" value={utils.formatNumber2(stk.d_Market_Direction_Limit)} />
                    </FormGroup>
                </div>
            </div> }
            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            <p>Notes</p>
            <div>
                <div>
                    Option Stock No. be be 9xxxxxx
                </div>
            </div >
        </div>
    )
}



interface FBSSmMastEditProps {
    gsb: AxiosInstance,
    stk?: FBSStkInfo,
    MarketList?: MarketInfo[],
    isNew?: boolean,
    onSave?: (stk: FBSStkInfo) => void,
    onCancel?: () => void;
}

function FBSSmMastEdit({ gsb, stk = {} as FBSStkInfo, MarketList=[] as MarketInfo[], isNew = false, onSave = () => { }, onCancel = () => { } }: FBSSmMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSStkInfo>()
    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [CurrencyList, setCurrencyList] = useState([] as CurrencyInfo[])
    const [CurrencyList2, setCurrencyList2] = useState([] as CurrencyInfo[])
    const [MarketFeeList, setMarketFeeList] = useState([] as MktFeeInfo[])
    
    const [MarketValue, setMarketValue] = useState(stk.d_Market)
    const [MarketFeeValue, setMarketFeeValue] = useState(stk.d_FeeCode)
    const [CurrencyValue, setCurrencyValue] = useState(stk.d_Currency)
    const [StkTypeValue, setStkTypeValue] = useState(stk.d_StkType)
    const [CCASSStockValue, setCCASSStockValue] = useState(stk.d_CcassStk)
    const [TradeSuspendedValue, setTradeSuspendedValue] = useState(stk.d_TradeSuspend)
    const [StampValue, setStampValue] = useState(stk.d_Stamp)
    const [StkGrade, setStkGrade] = useState(stk.d_Grade)


    const [ListdateValue, setListdateValue] = useState(utils.formatNumber(new Date()))
    const Mindate1 = new Date(1800, 0, 1)
    const Maxdate1 = addDays(new Date(), 365*5)

    
    const dateFnsFormat = "dd-MM-yyyy";
    const formatDate = useCallback((date: Date) => format(date, dateFnsFormat), []);
    const parseDate = useCallback((str: string) => parse(str, dateFnsFormat, new Date()), []);


    useEffect(() => {
        (async () => {
            const res = await gsb.post('/GsbFlag');
            GsbFlag = res.data.Flag;
        })()

    }, [gsb])
    
    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    console.log("ClMastEdit UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            //setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, stk])


    useEffect(() => {
        (async () => {
            try {
                // get Currency List
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "CCYMast", cAction: "GetCCYList"})

                for (let j = 0; j < res.data.data.length; j++) {
                    CurrencyList2.push({d_Currency: res.data.data[j][0], d_CcyDesc: res.data.data[j][1]})
                }
                setCurrencyList(CurrencyList2)
                //console.log("set Currency List2: ", CurrencyList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    

    useEffect(() => {
        (async () => {
            try {
                // get Instruction Code Info
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "MktFeeMast", cAction: "GetMarketFeeCode", cMarketCode: MarketValue, cSysCode: "Fbsx"})
                
                if ( MarketValue.trim().length > 0 && res.data.count > 0 )
                {
                    setMarketFeeList(res.data.data)
                } else { 
                    setMarketFeeList([])
                    setMarketFeeValue("")
                    setCurrencyValue("")
                }
            
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, MarketValue])
    
    useEffect(() => {
        // Call reset to get the values of record FBSStkInfo 
        if ("d_StkNo" in stk) {
            reset(stk)
        }
    }, [stk, reset])

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it (d_Market) manually and call setValue when item is selected
        register({ name: "d_Market" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    

    if (! isNew && ! ("d_StkNo" in stk)) return null


    function handleSuspendChange(value: string) {
        stk.d_TradeSuspend = value.toString();
        setTradeSuspendedValue(value.toString());
        //console.log("handleSuspendChange stk.d_TradeSuspend ", stk.d_TradeSuspend )
        //console.log("handleSuspendChange TradeSuspendedValue ", TradeSuspendedValue )
        return null;
    }
    

    const onSubmit = (data: FBSStkInfo) => {

        //console.log("FBSSmMastedit onsubmit data: ", data)

        // put value to json/field before write database dbf

        data.d_Market = MarketValue
        if ( typeof(data.d_Market) === "undefined" ) {
            data.d_Market = ""
        }
        data.d_Market = data.d_Market.toUpperCase();

        data.d_FeeCode = MarketFeeValue
        if ( typeof(data.d_FeeCode) === "undefined" ) {
            data.d_FeeCode = ""
        }

        data.d_Currency = CurrencyValue
        if ( typeof(data.d_Currency) === "undefined" ) {
            data.d_Currency = ""
        }
        data.d_Currency = data.d_Currency.toUpperCase();

        data.d_StkCode = data.d_StkCode.toUpperCase();
        data.d_Market = data.d_Market.toUpperCase();
        data.d_FeeCode = data.d_FeeCode.toUpperCase();
        data.d_Currency = data.d_Currency.toUpperCase();

        data.d_StkType = StkTypeValue;
        data.d_CcassStk = CCASSStockValue

        data.d_Stamp = StampValue;
        data.d_TradeSuspend = TradeSuspendedValue;
        data.d_Grade = StkGrade;


        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }
        
        ;

        (async () => {
            try {
                //console.log("call FBSSmMastedit data", data)
                //console.log("call FBSSmMastedit isNew", isNew)
                const res = await gsb.post('/fbs/Master', {sb_data: data, cPgmId: "FBSSmMast", cAction: "SmValidate", isNew: isNew})
                //console.log("FBSSmMastedit res.data.ok", res.data.ok)
                //console.log("FBSSmMastedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

        //onSave(data)
    }


     const MktRenderer: ItemRenderer<MarketInfo> = (MarketList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${MarketList.d_MktName}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={MarketList.d_Market}
                key={MarketList.d_Market}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const MktPredicate: ItemPredicate<MarketInfo> = (query, MarketList, _index, exactMatch) => {
        const normalizedText = `${MarketList.d_Market} - ${MarketList.d_MktName}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const MktValueRenderer = (MarketList: MarketInfo) => {
        return MarketList.d_Market
    }

    const MktFeeRenderer: ItemRenderer<MktFeeInfo> = (MarketFeeList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${MarketFeeList.d_FeeCode}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={MarketFeeList.d_FeeCode}
                key={MarketFeeList.d_FeeCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const MktFeePredicate: ItemPredicate<MktFeeInfo> = (query, MarketFeeList, _index, exactMatch) => {
        const normalizedText = `${MarketFeeList.d_FeeCode} - ${MarketFeeList.d_FeeCode}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const MktFeeValueRenderer = (MarketFeeList: MktFeeInfo) => {
        return MarketFeeList.d_FeeCode
    }

    const CurrencyRenderer: ItemRenderer<CurrencyInfo> = (CurrencyList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${CurrencyList.d_CcyDesc}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={CurrencyList.d_Currency}
                key={CurrencyList.d_Currency}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const CurrencyPredicate: ItemPredicate<CurrencyInfo> = (query, CurrencyList, _index, exactMatch) => {
        const normalizedText = `${CurrencyList.d_Currency} - ${CurrencyList.d_CcyDesc}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const CurrencyValueRenderer = (CurrencyList: CurrencyInfo) => {
        return CurrencyList.d_Currency
    }


    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }





    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Stock No." labelFor="inputStkNo" labelInfo="*">
                    <InputGroup disabled={! isNew} id="inputStkNo" name="d_StkNo" autoFocus={isNew} defaultValue="" inputRef={register({ required: true }) } />
                    {errors.d_StkNo && errors.d_StkNo.type === "required" && (<span id="Err_msg">Stock No. cannot be Blank</span>)}
                    {errors.d_StkNo && errors.d_StkNo.types && <span id="Err_msg">{errors.d_StkNo.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="Stock Code" labelFor="inputStkCode" labelInfo="*">
                    <InputGroup id="inputStkCode" name="d_StkCode" autoFocus={! isNew} defaultValue="" placeholder="Stock Code is 15 chars ..." inputRef={register({ required: true , maxLength: 15 }) } />
                    {errors.d_StkCode && errors.d_StkCode.type === "required" && <span id="Err_msg">Stock Code cannot be Blank</span>}
                    {errors.d_StkCode && errors.d_StkCode.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.d_StkCode && errors.d_StkCode.types && <span id="Err_msg">{errors.d_StkCode.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-5" label="Stock Name" labelFor="inputStkName">
                    <InputGroup id="inputStkName" name="d_StkName" defaultValue="" placeholder="Stock Name ..." inputRef={register({ maxLength: 45}) } />
                    {errors.d_StkName && errors.d_StkName.type === "maxLength" && <span id="Err_msg">Max length is 45</span>}
                    {errors.d_StkName && errors.d_StkName.types && <span id="Err_msg">{errors.d_StkName.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-5" label="Stock Chinese Name" labelFor="inputStkChiName">
                    <InputGroup id="inputStkChiName" name="d_Chi_Name_bg5" defaultValue="" placeholder="Stock Chinese Name (Big5) ..." inputRef={register({ maxLength: 30}) } />
                    {errors.d_Chi_Name_bg5 && errors.d_Chi_Name_bg5.type === "maxLength" && <span id="Err_msg">Max length is 30</span>}
                    {errors.d_Chi_Name_bg5 && errors.d_Chi_Name_bg5.types && <span id="Err_msg">{errors.d_Chi_Name_bg5.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Market Code" labelFor="inputMarketCode">
                    <Suggest
                        inputProps={{ placeholder: "Market Code ..." }}
                        activeItem={MarketList.find((mkt) => mkt.d_Market === MarketValue)}
                        defaultSelectedItem={MarketList.find((mkt) => mkt.d_Market === MarketValue)}
                        items={MarketList}
                        itemRenderer={MktRenderer}
                        itemPredicate={MktPredicate}
                        inputValueRenderer={MktValueRenderer}
                        onItemSelect={(mkt) => { setMarketValue(mkt.d_Market) }}
                    />
                    {errors.d_Market && errors.d_Market.types && <span id="Err_msg">{errors.d_Market.types.message}</span>}
                </FormGroup>
                { ( MarketValue.trim().length > 0 ) && <FormGroup className="Col3-2-1" label="Fee Code" labelFor="inputFeeCode">
                    <Suggest2
                        inputProps={{ placeholder: "Fee Code ..." }}
                        activeItem={MarketFeeList.find((mkt) => mkt.d_FeeCode === MarketFeeValue)}
                        selectedItem={MarketFeeList.find((mkt) => mkt.d_FeeCode === MarketFeeValue)}
                        items={MarketFeeList}
                        itemRenderer={MktFeeRenderer}
                        itemPredicate={MktFeePredicate}
                        inputValueRenderer={MktFeeValueRenderer}
                        onItemSelect={(mkt) => { setMarketFeeValue(mkt.d_FeeCode) }}
                    />
                    {errors.d_FeeCode && errors.d_FeeCode.types && <span id="Err_msg">{errors.d_FeeCode.types.message}</span>}
                </FormGroup> }
                { ! ( MarketValue.trim().length > 0 ) && <FormGroup className="Col-2-1" label="Fee Code" labelFor="inputFeeCode">
                    <InputGroup readOnly value={MarketFeeValue} />
                </FormGroup> }
                { ( MarketValue.trim().length > 0 ) && <FormGroup className="Col3-3-1" label="Currency" labelFor="inputCurency">
                    <Suggest2
                            inputProps={{ placeholder: "Currency ..." }}
                            activeItem={CurrencyList.find((Ccy) => Ccy.d_Currency === CurrencyValue)}
                            selectedItem={CurrencyList.find((Ccy) => Ccy.d_Currency === CurrencyValue)}
                            items={CurrencyList}
                            itemRenderer={CurrencyRenderer}
                            itemPredicate={CurrencyPredicate}
                            inputValueRenderer={CurrencyValueRenderer}
                            onItemSelect={(Ccy) => { setCurrencyValue(Ccy.d_Currency) }}
                        />
                    {errors.d_Currency && errors.d_Currency.types && <span id="Err_msg">{errors.d_Currency.types.message}</span>}
                </FormGroup> }
                { ! ( MarketValue.trim().length > 0 ) && <FormGroup className="Col-3-1" label="Currency" labelFor="inputCurency">
                    <InputGroup readOnly value={CurrencyValue} />
                </FormGroup> }
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Type" labelFor="inputStkType">
                    <select  id="inputStkType" name="d_StkType" value={StkTypeValue} onChange={utils.handleStringChange(s => setStkTypeValue(s)) } ref={register}>
                        <option value=" "> </option>
                        <option value="O">O: Options</option>
                    </select>
                    {errors.d_StkType && errors.d_StkType.types && <span id="Err_msg">{errors.d_StkType.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-1-2" label="Warrant/Rights Expiry Date"labelFor="inputExpiryDate">
                    <InputGroup id="inputExpiryDate" name="d_ExpiryDate" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_ExpiryDate && errors.d_ExpiryDate.types && <span id="Err_msg">{errors.d_ExpiryDate.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="CCASS Stock" labelFor="inputCcassStk">
                    <RadioGroup
                        name="d_CcassStk"
                        inline={true}
                        selectedValue={CCASSStockValue}
                        onChange={utils.handleStringChange(s => setCCASSStockValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_Stamp && errors.d_Stamp.types && <span id="Err_msg">{errors.d_Stamp.types.message}</span>}
                    {errors.d_CcassStk && errors.d_CcassStk.types && <span id="Err_msg">{errors.d_CcassStk.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="CCASS Trade On"labelFor="inputCcassTradeOn">
                    <InputGroup id="inputCcassTradeOn" name="d_CcassTradeOn" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_CcassTradeOn && errors.d_CcassTradeOn.types && <span id="Err_msg">{errors.d_CcassTradeOn.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Contract Stamp" labelFor="inputStamp">
                    <RadioGroup
                        name="d_Stamp"
                        inline={true}
                        selectedValue={StampValue}
                        onChange={utils.handleStringChange(s => setStampValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_Stamp && errors.d_Stamp.types && <span id="Err_msg">{errors.d_Stamp.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Trade Suspended" labelFor="inputTradeSuspend">
                    <RadioGroup
                        name="d_TradeSuspend"
                        inline={true}
                        selectedValue={TradeSuspendedValue}
                        onChange={utils.handleStringChange(s => setTradeSuspendedValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_TradeSuspend && errors.d_TradeSuspend.types && <span id="Err_msg">{errors.d_TradeSuspend.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Lot Size" labelFor="inputLotSize">
                    <InputGroup id="inputLotSize" name="d_LotSize" defaultValue="0" type="number" inputRef={register({min: 0})} />
                    {errors.d_LotSize && errors.d_LotSize.type === "min" && <span id="Err_msg">Lot Size sholud be greater than 0 </span>}
                    {errors.d_LotSize && errors.d_LotSize.types && <span id="Err_msg">{errors.d_LotSize.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Price" labelFor="inputStkPrice">
                    <InputGroup className="inputNumberNoSpin" id="inputStkPrice" name="d_StkPrice" defaultValue="0" type="number" inputRef={register} />
                    {errors.d_StkPrice && errors.d_StkPrice.types && <span id="Err_msg">{errors.d_StkPrice.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Grade" labelFor="inputGrade">
                    <select  id="inputGrade" name="d_Grade" value={StkGrade} onChange={utils.handleStringChange(s => setStkGrade(s)) } ref={register}>
                        <option value=" "> : Others</option>
                        <option value="A">A: HSI</option>
                        <option value="B">B: HS LargeCap Stock</option>
                        <option value="C">C: Other Stock</option>
                        <option value="D">D: Warrant</option>
                        <option value="E">E: User Defined</option>
                    </select>
                    {errors.d_Grade && errors.d_Grade.types && <span id="Err_msg">{errors.d_Grade.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Margin Ratio">
                    <InputGroup className="inputNumberNoSpin" id="inputMarginRatio" name="d_MarginRatio" defaultValue="0" type="number" inputRef={register} />
                    {errors.d_MarginRatio && errors.d_MarginRatio.types && <span id="Err_msg">{errors.d_MarginRatio.types.message}</span>}
                </FormGroup>
            </div>
            { StkTypeValue == "O" && <div >
                <div className="Row">
                    <FormGroup className="Col-1-4"  >
                        <span id="DispText">For Option</span>
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-2" label="(Option) Underlying Stock No." labelFor="inputUnderlying_StkNo" labelInfo="">
                        <InputGroup disabled={false} id="inputUnderlying_StkNo" name="d_Underlying_StkNo" defaultValue="" inputRef={register} />
                        {errors.d_Underlying_StkNo && errors.d_Underlying_StkNo.type === "required" && (<span id="Err_msg">Underlying Stock No. cannot be Blank</span>)}
                        {errors.d_Underlying_StkNo && errors.d_Underlying_StkNo.types && <span id="Err_msg">{errors.d_Underlying_StkNo.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-3-1" label="Option Code" labelFor="inputRegister" labelInfo="">
                        <InputGroup id="inputRegister" name="d_Register" defaultValue="" placeholder="Option Code is 15 chars ..." inputRef={register({ maxLength: 15 }) } />
                        {errors.d_Register && errors.d_Register.type === "required" && <span id="Err_msg">Option Code cannot be Blank</span>}
                        {errors.d_Register && errors.d_Register.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                        {errors.d_Register && errors.d_Register.types && <span id="Err_msg">{errors.d_Register.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-4-1" label="Trading Tariff" labelFor="inputTariff" labelInfo="">
                        <InputGroup id="inputTariff" name="d_Tariff" defaultValue="0" type="number" inputRef={register({min: 0})} />
                        {errors.d_Tariff && errors.d_Tariff.type === "min" && <span id="Err_msg">"Trading Tariff sholud be greater than 0 </span>}
                        {errors.d_Tariff && errors.d_Tariff.types && <span id="Err_msg">{errors.d_Tariff.types.message}</span>}
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-3-1" label="Option Code V1" labelFor="inputRegister" labelInfo="">
                        <InputGroup id="inputRegister" name="d_Register1" defaultValue="" placeholder="Option Code is 15 chars ..." inputRef={register({ maxLength: 15 }) } />
                        {errors.d_Register1 && errors.d_Register1.type === "required" && <span id="Err_msg">Option Code cannot be Blank</span>}
                        {errors.d_Register1 && errors.d_Register1.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                        {errors.d_Register1 && errors.d_Register1.types && <span id="Err_msg">{errors.d_Register1.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-4-1" label="Trading Tariff V1" labelFor="inputTariff" labelInfo="">
                        <InputGroup id="inputTariff" name="d_Tariff1" defaultValue="0" type="number" inputRef={register({min: 0})} />
                        {errors.d_Tariff1 && errors.d_Tariff1.type === "min" && <span id="Err_msg">"Trading Tariff sholud be greater than 0 </span>}
                        {errors.d_Tariff1 && errors.d_Tariff1.types && <span id="Err_msg">{errors.d_Tariff1.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-5-1" label="Lot Size V1" labelFor="inputRegister_LotSize" labelInfo="">
                        <InputGroup id="inputTariff" name="d_Register1_LotSize" defaultValue="0" type="number" inputRef={register({min: 0})} />
                        {errors.d_Register1_LotSize && errors.d_Register1_LotSize.type === "min" && <span id="Err_msg">"Lot Size  sholud be greater than 0 </span>}
                        {errors.d_Register1_LotSize && errors.d_Register1_LotSize.types && <span id="Err_msg">{errors.d_Register1_LotSize.types.message}</span>}
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-3-1" label="Option Code V2" labelFor="inputRegister" labelInfo="">
                        <InputGroup id="inputRegister" name="d_Register2" defaultValue="" placeholder="Option Code is 15 chars ..." inputRef={register({ maxLength: 15 }) } />
                        {errors.d_Register2 && errors.d_Register2.type === "required" && <span id="Err_msg">Option Code cannot be Blank</span>}
                        {errors.d_Register2 && errors.d_Register2.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                        {errors.d_Register2 && errors.d_Register2.types && <span id="Err_msg">{errors.d_Register2.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-4-1" label="Trading Tariff V2" labelFor="inputTariff" labelInfo="">
                        <InputGroup id="inputTariff" name="d_Tariff2" defaultValue="0" type="number" inputRef={register({min: 0})} />
                        {errors.d_Tariff2 && errors.d_Tariff2.type === "min" && <span id="Err_msg">"Trading Tariff sholud be greater than 0 </span>}
                        {errors.d_Tariff2 && errors.d_Tariff2.types && <span id="Err_msg">{errors.d_Tariff2.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-5-1" label="Lot Size V2" labelFor="inputRegister_LotSize" labelInfo="">
                        <InputGroup id="inputTariff" name="d_Register2_LotSize" defaultValue="0" type="number" inputRef={register({min: 0})} />
                        {errors.d_Register2_LotSize && errors.d_Register2_LotSize.type === "min" && <span id="Err_msg">"Lot Size  sholud be greater than 0 </span>}
                        {errors.d_Register2_LotSize && errors.d_Register2_LotSize.types && <span id="Err_msg">{errors.d_Register2_LotSize.types.message}</span>}
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-3-1" label="Option Code V3" labelFor="inputRegister" labelInfo="">
                        <InputGroup id="inputRegister" name="d_Register3" defaultValue="" placeholder="Option Code is 15 chars ..." inputRef={register({ maxLength: 15 }) } />
                        {errors.d_Register3 && errors.d_Register3.type === "required" && <span id="Err_msg">Option Code cannot be Blank</span>}
                        {errors.d_Register3 && errors.d_Register3.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                        {errors.d_Register3 && errors.d_Register3.types && <span id="Err_msg">{errors.d_Register3.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-4-1" label="Trading Tariff V3" labelFor="inputTariff" labelInfo="">
                        <InputGroup id="inputTariff" name="d_Tariff3" defaultValue="0" type="number" inputRef={register({min: 0})} />
                        {errors.d_Tariff3 && errors.d_Tariff3.type === "min" && <span id="Err_msg">"Trading Tariff sholud be greater than 0 </span>}
                        {errors.d_Tariff3 && errors.d_Tariff3.types && <span id="Err_msg">{errors.d_Tariff3.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-5-1" label="Lot Size V3" labelFor="inputRegister_LotSize" labelInfo="">
                        <InputGroup id="inputTariff" name="d_Register3_LotSize" defaultValue="0" type="number" inputRef={register({min: 0})} />
                        {errors.d_Register3_LotSize && errors.d_Register3_LotSize.type === "min" && <span id="Err_msg">"Lot Size  sholud be greater than 0 </span>}
                        {errors.d_Register3_LotSize && errors.d_Register3_LotSize.types && <span id="Err_msg">{errors.d_Register3_LotSize.types.message}</span>}
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-2" label="Option Position Limit" labelFor="inputOption_Position_Limit">
                        <InputGroup id="inputOption_Position_Limit" name="d_Option_Position_Limit" defaultValue="0" type="number" inputRef={register({min: 0})} />
                        {errors.d_Option_Position_Limit && errors.d_Option_Position_Limit.type === "min" && <span id="Err_msg">"Option Position Limit sholud be greater than 0 </span>}
                        {errors.d_Option_Position_Limit && errors.d_Option_Position_Limit.types && <span id="Err_msg">{errors.d_Option_Position_Limit.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-3-2" label="Market Direction Limit" labelFor="inputMarket_Direction_Limit">
                        <InputGroup className="inputNumberNoSpin" id="inputMarket_Direction_Limit" name="d_Market_Direction_Limit" defaultValue="0" type="number" inputRef={register({min: 0})} />
                        {errors.d_Market_Direction_Limit && errors.d_Market_Direction_Limit.type === "min" && <span id="Err_msg">"Market Direction Limit sholud be greater than 0 </span>}
                        {errors.d_Market_Direction_Limit && errors.d_Market_Direction_Limit.types && <span id="Err_msg">{errors.d_Market_Direction_Limit.types.message}</span>}
                    </FormGroup>
                </div>
            </div> }
            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            <p>Notes</p>
            <div>
                <div>
                    Option Stock No. be be 9xxxxxx
                </div>
            </div >
        </form>
    )
}


interface FBSSmMastMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function FBSSmMastMain({ gsb }: FBSSmMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { StkNo: defaultSearchValue = "" }: { StkNo: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSStkInfo[])
    const [MarketList, setMarketList] = useState([] as MarketInfo[])

    const [searchKey, setSearchKey] = useState("StkNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchStkName, setsearchStkName] = useState("")
    const [searchMktCode, setsearchMktCode] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentStk, setCurrentStk] = useState({} as FBSStkInfo)
    const [BlankStk, setBlankStk] = useState({} as FBSStkInfo)
    const [CurrentLog, setCurrentLog] = useState({} as FBSStkInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //gsb default value
    BlankStk.d_Isin = ""   //no work
    BlankStk.d_Market = ""
    BlankStk.d_FeeCode = ""
    BlankStk.d_Currency = ""
    BlankStk.d_CcassStk = "Y"
    BlankStk.d_Stamp = "Y"
    BlankStk.d_TradeSuspend = "N"
    BlankStk.d_CcassTradeOn = "    -  -  "
    BlankStk.d_ExpiryDate = "    -  -  "


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("FBSSmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("FBSSmMastMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("FBSSmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("FBSSmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("FBSSmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("FBSSmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                UserID = res.data.Flag.UserID
                //console.log("FBSSmMastMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("FBSSmMastMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("FBSSmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("FBSSmMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])


    useEffect(() => {
        if (logviewonly === "Y") {
            setViewMode("L")
        }

        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/fbs/Master', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "FBSSmMast", 
                        cAction: "ViewLogRec"
                    })
                    console.log("FBSSmMastMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog(res.data.data[0])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])



    useEffect(() => {
        (async () => {
            try {
                // get Market List
                const res = await gsb.post('/Master',
                {   sb_data: {
                    by: "Market",
                    start: "",
                    nPage: 1,
                    limit: 0,
                    backward: false
                },
                cPgmId: "Mktmast",
                cAction: "ListRec",
                cSysCode: "Fbsx",
            });

            //console.log("MarketList: ", res.data.data) 
            res.data.data.unshift({d_Market: "", d_MktName: "blank"})
            setMarketList(res.data.data)
            //console.log("set MarketList: ", MarketList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    const PrevRecProcess = async (stk: FBSStkInfo) => {
        try {
            //console.log("call PrevRecProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: stk, cPgmId: "FBSSmMast", cAction: "PrevRec"})
            //console.log("PrevRecProcess show 1: ", stk.d_StkNo)
            //console.log("PrevRecProcess data : ", data)
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo === res.data.data.d_StkNo) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setCurrentStk(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (stk: FBSStkInfo) => {
        try {
            stk.d_AuthTran = ""
            if (isReqAuth2) {
                stk.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: stk, cPgmId: "FBSSmMast", cAction: "DelRec"})
            if (res.data.ok) {
                if (isReqAuth2) {
                    showSuccess("Stock No. " + stk.d_StkNo + " record deleting, waiting for authorization")
                } else {
                    showSuccess("Stock No. " + stk.d_StkNo + " record deleted")
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].d_StkNo === res.data.data.d_StkNo) {
                            data[i] = { ...data[i], ...res.data.data }
                            setData(data)
                            break
                        }
                    }
                }
                setCurrentStk(res.data.data)
                setCurrentMode("show")
                if (isReqAuth2) {
                    alert("Stock No. " + stk.d_StkNo + " record deleting, waiting for authorization")
                }
            } else {
                setisShowAlert2(true)
                setShowAlert2Msg(res.data.err_Msg)
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (stk: FBSStkInfo) => {
        try {
            //console.log("call NextRecProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: stk, cPgmId: "FBSSmMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo === res.data.data.d_StkNo) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentStk(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (stk: FBSStkInfo) => {
        try {
            //console.log("call newOnSave", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: stk, cPgmId: "FBSSmMast", cAction: "AddRec"})
            if (isReqAuth2) {
                showSuccess("Stock No. " + stk.d_StkNo + " record adding, waiting for authorization")
            } else {
                showSuccess("Stock No. " + stk.d_StkNo + " record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setCurrentStk(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                alert("Stock No. " + stk.d_StkNo + " record adding, waiting for authorization")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (stk: FBSStkInfo) => {
        try {
            //console.log("call editOnSave", stk)
            //console.log("stk.d_CcassStk: ", stk.d_CcassStk)
            const res = await gsb.post('/fbs/Master', {sb_data: stk, cPgmId: "FBSSmMast", cAction: "UpdateRec"})
            if (isReqAuth2) {
                showSuccess("Stock No. " + stk.d_StkNo + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo) {
                        setCurrentStk(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                alert("Stock No. " + stk.d_StkNo + " record saving, waiting for authorization")
            } else {
                showSuccess("Stock No. " + stk.d_StkNo + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo) {
                        data[i] = { ...data[i], ...res.data.data }
                        //console.log("editOnSave data", i, data)
                        setData(data)
                        //setCurrentStk(stk)
                        break
                    }
                }
                //console.log("editOnSave stk", stk)
                //console.log("editOnSave res.data.data", res.data.data)
                setCurrentStk(res.data.data)
                setCurrentMode("show")
                //setisShowAlert1(true)
                //setShowAlert1Msg("Account No. " +ac.d_acCode + " record saved")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        // get FBSSmMast list if StkNo have value
        try {
            //console.log("FBSSmMastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            StkName: searchStkName,
                            MktCode: searchMktCode,
                        }, 
                    },
                    cPgmId: "FBSSmMast",
                    cAction: "ListRec",
                });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentStk(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        d_StkNo: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "FBSSmMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setCurrentStk(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    // get one FBSSmMast record if StkNo have value
    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            // console.log("calling API for URL param");

            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("FBSSmMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "StkNo",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "FBSSmMast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentStk(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                StkName: searchStkName,
                                MktCode: searchMktCode,
                            }, 
                        },
                        cPgmId: "FBSSmMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentStk(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    // currentMode = show
    let detail = <FBSSmMastView gsb={gsb} stk={currentStk} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentStk)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentStk)} onNextRec={() => NextRecProcess(currentStk)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></FBSSmMastView>
    switch (currentMode) {
        //case "PrevRec":
        // ?? will call 2 times ??
        //    console.log("currentMode = PrevRec")
        //    PrevRecProcess(currentStk)
        //    break
        case "new":
            //console.log("currentMode = new")
            detail = <FBSSmMastEdit gsb={gsb} stk={BlankStk} MarketList={MarketList} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } ></FBSSmMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSSmMastEdit gsb={gsb} stk={currentStk} MarketList={MarketList} onSave={editOnSave} onCancel={() => setCurrentMode("show")} ></FBSSmMastEdit>
            break
        //case "delete":
        //    console.log("currentMode = delete")
        //    DeleteProcess(currentStk)
        //    break
    }

    let logKeyViewRec = <FBSSmMastView gsb={gsb} stk={CurrentLog} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentStk)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentStk)} onNextRec={() => NextRecProcess(currentStk)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></FBSSmMastView>


    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>


    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-StkNo">Stock No</th>
                <th className="TCol-StkCode">Stock Code</th>
                <th className="TCol-StkName">Stock Name</th>
                <th className="TCol-CcassStk">CCASS</th>
                <th className="TCol-Stamp">Stamp</th>
                <th className="TCol-LotSize">Lot Size</th>
                <th className="TCol-StkNo">Martet Code</th>
                <th className="TCol-StkNo">Fee Code</th>
                <th className="TCol-StkNo">Currency</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((stk, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td className="TCol-StkNo" onClick={() => { setCurrentStk(stk) ; MoblieDev && setSelectedTabId("detail") }}>{stk.d_StkNo}</td>
                        <td className="TCol-StkCode" onClick={() => { setCurrentStk(stk) ; MoblieDev && setSelectedTabId("detail") }}>{stk.d_StkCode}</td>
                        <td className="TCol-StkName" onClick={() => { setCurrentStk(stk) }}>{stk.d_StkName}</td>
                        <td className="TCol-CcassStk" onClick={() => { setCurrentStk(stk) }}>{stk.d_CcassStk}</td>
                        <td className="TCol-Stamp" onClick={() => { setCurrentStk(stk) }}>{stk.d_Stamp}</td>
                        <td className="TCol-LotSize" onClick={() => { setCurrentStk(stk) }}>{stk.d_LotSize}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentStk(stk) ; MoblieDev && setSelectedTabId("detail") }}>{stk.d_Market}</td>              
                        <td className="TCol-StkNo" onClick={() => { setCurrentStk(stk) ; MoblieDev && setSelectedTabId("detail") }}>{stk.d_FeeCode}</td>              
                        <td className="TCol-StkNo" onClick={() => { setCurrentStk(stk) ; MoblieDev && setSelectedTabId("detail") }}>{stk.d_Currency}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    {/* define search key */}
                    <H3><div style={{justifyContent: 'flex-end'}}>Stock Master</div></H3>
                    <div className="Row">
                        <FormGroup className="Col-1-5" label="Search for " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="StkNo">Stock No</option>
                                    <option value="StkCode">Stock Code</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "StkNo"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "StkNo"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                    </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-5" label="Stock Name" labelFor="searchStkName">
                                <InputGroup id="searchStkName" value={searchStkName} onChange={utils.handleStringChange(s => setsearchStkName(s))} />
                            </FormGroup>
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                        <div className="Row">
                            <FormGroup className="Col-1-1" label="Market Code" labelFor="searchMktCode">
                                <InputGroup id="searchMktCode" value={searchMktCode} onChange={utils.handleStringChange(s => setsearchMktCode(s))} />
                            </FormGroup>
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Stock Master Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>
            </form>
        </>
    );
}

export default FBSSmMastMain